import { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from '../../../SearchBars.styled';

type SearchClientBarProps = {
    mobile: boolean;
    handleSearchInput?: (data: string) => void;
    onChange?: (value: string) => void;
    value?: string;
    placeHolder?: string;
    containerStyle?: React.CSSProperties;
};

const SearchClientBar = ({
    mobile,
    handleSearchInput,
    onChange,
    value,
    placeHolder,
    containerStyle,
}: SearchClientBarProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [searchInput, setSearchInput] = useState(value ?? '');
    const isControlled = value !== undefined;

    useEffect(() => {
        if (isControlled) {
            setSearchInput(value ?? '');
        }
    }, [isControlled, value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextValue = e.target.value;

        if (!isControlled) {
            setSearchInput(nextValue);
        }

        handleSearchInput?.(nextValue);
        onChange?.(nextValue);
    };

    return (
        <S.Container
            style={
                mobile
                    ? { maxWidth: '100%', minWidth: '100%', ...containerStyle }
                    : { maxWidth: '32%', minWidth: '32%', ...containerStyle }
            }
        >
            <S.SearchContainer style={{ maxWidth: '100%', minWidth: '100%' }}>
                <S.SearchInput
                    type="text"
                    placeholder={placeHolder ? placeHolder : t('clientName', { lng: language })}
                    onChange={handleChange}
                    value={isControlled ? (value ?? '') : searchInput}
                    style={{ maxWidth: mobile ? '85%' : '' }}
                />

                <SearchIcon style={{ width: '14px' }} />
            </S.SearchContainer>
        </S.Container>
    );
};

export default SearchClientBar;
